import { createStore, compose, applyMiddleware } from "redux";
import rootReducer from "./reducer";
import sliderOnChangeReducer from "./sliderOnChangeReducer";
import sliderDataReducer from "./sliderDataReducer";
import { combineReducers } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import omit from "lodash/omit";
import { configureStore } from "@reduxjs/toolkit";
import priceReducer from "./priceReducer";

const blacklistPaths = [
  "trading.PRICES",
  "trading.REFRESH_ORDER",
  "trading.HISTORIC_DATA",
  "trading.REFRESH_PAGE_POPUP",
  // "trading.COIN_ICONS",
  "sliderDataReducer.prices",
  "sliderChange.price",
];

const persistConfig = {
  key: "root",
  storage: storage,
  // whitelist: ["authType"], // which reducer want to store
  transforms: [
    // nested blacklist-paths require a custom transform to be applied
    createTransform((inboundState, key) => {
      const blacklistPaths_forKey = blacklistPaths
        .filter((path) => path.startsWith(`${key}.`))
        .map((path) => path.substr(key.length + 1));
      return omit(inboundState, ...blacklistPaths_forKey);
    }, null),
  ],
  stateReconciler: autoMergeLevel2,
};

const reducer = combineReducers({
  trading: rootReducer,
  sliderChange: sliderOnChangeReducer,
  sliderDataReducer: sliderDataReducer,
  priceReducer: priceReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export default store;
